module.exports = __webpack_public_path__ + "static/media/shipping.3f8753f0.png";